// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__VAlTz","content":"style_content__Ufucq","text":"style_text__3K9we"};